import Stylus from './Stylus';
import PenBrush from './PenBrush';
import PenMenu from '../toolbars/PenMenu';
import penIcon from '../assets/icons/pen.svg';
import { svgToIcon } from '../utils/svg';

// Free drawing pen
class StylusPen extends Stylus {
  activate() {
    const canvas = this.controller.canvas;
    const brush = new PenBrush(canvas);
    brush.decimate = 3;
    brush.color = 'rgba(60, 60, 60, 0.8)';
    brush.width = 2;

    canvas.isDrawingMode = true;
    canvas.freeDrawingBrush = brush;
  }

  // Override the default behavior to reset to the pointer.
  drawingComplete() {}

  cursor() {
    return 'crosshair';
  }

  renderIcon() {
    return svgToIcon(penIcon);
  }

  description() {
    return 'Pen';
  }

  alwaysLockWhenSelected() {
    return true;
  }

  subMenu() {
    return PenMenu;
  }
}

export default StylusPen;
